<template>
    <form-select v-model="selected.value"
                 :label="option.name"
                 :options="option.values"
                 display-by="label"
                 :track-as-integer="true"
                 :bold="true"
    ></form-select>
</template>

<script>
    import FormSelect from "../../form/Select";

	export default {
	    data() {
	        return {
	            selected: {}
            }
        },

        model: {
	        event: 'change',
        },

	    props: {
	        option: {
	            type: Object,
                required: true,
            },

            value: {
	            required: true
            }
        },

        watch: {
            selected: function (value) {
                this.$emit('change', value)
            }
        },

	    components: { FormSelect },

        created() {
	        this.selected = _.cloneDeep(this.value);

	        _.forEach(this.option.values, value => {
	            value.label = this.option.system_id !== 'amount' && parseFloat(value.formatted_price) > 0 ?
                    `${value.name} (+£${value.formatted_price})` : value.name;
            });
        },
    }
</script>
